import {
  // CONCORDIUM_WALLET_CONNECT_PROJECT_ID,
  MAINNET,
  TESTNET,
  WalletConnectConnector,
  ephemeralConnectorType,
  WalletConnectEvent,
  WalletConnectMethod,
  BrowserWalletConnector,
  CONCORDIUM_WALLET_CONNECT_PROJECT_ID,
} from '@concordium/react-components'
import { isProd } from './utils/isProd'
import { isPanenkaFCUrl } from './utils/isPanenkaFCUrl'
import { Environment } from '@getpara/react-sdk'

const PARA_PROD_KEY = import.meta.env.VITE_PARA_PROD_KEY
const PARA_DEV_KEY = import.meta.env.VITE_PARA_DEV_KEY

export const pageSizes = {
  small: 10,
  medium: 20,
  big: 50,
  super: 100,
}

export const DEFAULT_PLAYER_FILTERS = {
  page: 1,
  take: pageSizes.medium,
  sortBy: 'cost',
  sortOrder: 'DESC',
}

export const NET = isProd ? MAINNET : TESTNET

export const RECEIVER_ADDRESS = isProd
  ? '4NyaTPrcrwSQ1sGGjDAjeWMz8ZNRRWphDHex46aSW1VPM2wZwr'
  : '3zdLnv2NRjEEJ53PsUENXF8mhPFtgnD9TmfQMJGaHiQpeFcz3j'

export const googleConstants = {
  clientId:
    '1052068475021-racsgjbvs1531tmdf9bueand07bl3a9f.apps.googleusercontent.com',
  measuringId: 'G-4FBK8EYFWB',
}

export const wertConstants = {
  address: isProd ? 9390 : 7260,
  partnerId: isProd
    ? '01HQJVWPRN9FF86TEA2W1DS86Y'
    : '01HNZ92PXHBA51K90Z3AZCW4FH',
  defaultCommodity: isProd
    ? '[{"commodity": "USDT","network":"polygon"}]'
    : '[{"commodity": "MATIC","network":"mumbai"}]',
  origin: isProd ? 'https://widget.wert.io' : 'https://sandbox.wert.io',
  // ccdCommodity: `[{"commodity": "CCD", "network":  ${
  //   isProd ? '"concordium"' : '"testnet"'
  // } }, {"commodity": "EUROe", "network":  ${
  //   isProd ? '"mainnet"' : '"testnet"'
  // } } ]`,
  ccdCommodity: JSON.stringify([
    {
      commodity: 'CCD',
      network: isProd ? 'concordium' : 'testnet',
    },
  ]),
}

export const BROWSER_WALLET_NAME = 'Browser Wallet'
export const MOBILE_WALLET_NAME = 'Mobile Wallet'

export const CONCORDIUM = 'concordium'
export const POLYGON = 'polygon'
export const XDC = 'xdc'
export const CAMP = 'camp'
export const CCD = 'ccd'
export const STRK = 'strk'
export const ETH = 'eth'
export const STARKNET = 'starknet'

export const MICRO = 1000000 // 10*6

// genrated from Smart contract - cargo concordium build --schema-json-out ./
export const SERIALIZATION_HELPER_SCHEMA_ADDITIONAL_DATA =
  'FAAFAAAADQAAAHNob3VsZF9lbnJvbGwBCQAAAHVzZXJfbmFtZRUCAAAABAAAAE5vbmUCBAAAAFNvbWUBAQAAABYCDAAAAGdhbWVfcm9vbV9pZBUCAAAABAAAAE5vbmUCBAAAAFNvbWUBAQAAABYCCQAAAHRlYW1fbmFtZRUCAAAABAAAAE5vbmUCBAAAAFNvbWUBAQAAABYCBgAAAGxpbmV1cBUCAAAABAAAAE5vbmUCBAAAAFNvbWUBAQAAABYC'

export const CCD_CONTRACT = 'ccd_contract'

export const CCD_CONTRACT_JOIN_GAME_ROOM_SHCEMA =
  'FAADAAAABwAAAHVzZXJfaWQWAgcAAAB0ZWFtX2lkFgIMAAAAZ2FtZV9yb29tX2lkFgI='

export const CCD_CONTRACT_VIEW_SCHEMA =
  'FAAQAAAAAgAAAGlkFgIFAAAAc3RhcnQNAwAAAGVuZA0NAAAAZ2FtZV9yb29tX2VuZA0OAAAAZ2FtZV9yb29tX3R5cGUVAwAAAAkAAABTcG9uc29yZWQCDQAAAFNlbGZQcm9tb3RpbmcCGQAAAFNwb25zb3JlZEFuZFNlbGZQcm9tb3RpbmcCDgAAAHRvdGFsX2V4cGVuc2VzCgYAAAB3aW5uZXIVAgAAAAQAAABOb25lAgQAAABTb21lAQEAAAALCQAAAGVudHJ5X2ZlZQoLAAAAZW50cnlfbGltaXQDBwAAAGJhbGFuY2UKBQAAAHByaXplBQoAAABjb21taXNzaW9uBQ4AAABydW5uZXJ1cF9wcml6ZQUSAAAAcGFydGljaXBhbnRzX2NvdW50AxMAAABudW1iZXJfb2ZfcnVubmVydXBzAxQAAABwYWlkX3J1bm5lcnVwc19jb3VudAM='

const WALLET_CONNECT_PROJECT_ID = '16b1ca7c7d713406b723845662426151'

const isPanenkaUrl = isPanenkaFCUrl(window.location.origin)

const WALLET_CONNECT_OPTS = {
  projectId: isPanenkaUrl
    ? WALLET_CONNECT_PROJECT_ID
    : CONCORDIUM_WALLET_CONNECT_PROJECT_ID, // if the enviroment/page is not on Panenka's domain we use Concordiums Id
  metadata: {
    name: 'Panenka FC',
    description: 'Fantasy Football',
    url: isProd ? 'https://www.panenkafc.gg' : 'https://test.panenkafc.gg',
    icons: ['https://walletconnect.com/walletconnect-logo.png'],
  },
}

export const WALLET_CONNECT_SCOPE = {
  methods: [
    WalletConnectMethod.SignMessage,
    WalletConnectMethod.SignAndSendTransaction,
  ],
  events: [WalletConnectEvent.AccountsChanged, WalletConnectEvent.ChainChanged],
}

export const WALLET_CONNECT = ephemeralConnectorType((delegate, network) =>
  WalletConnectConnector.create(
    WALLET_CONNECT_OPTS,
    delegate,
    network,
    WALLET_CONNECT_SCOPE
  )
)

export const BROWSER_XTENSION_WALLET = ephemeralConnectorType(
  BrowserWalletConnector.create
)

export const DEFAULT_TIEMOUT = 60000 // 60 sec

export const passwordValidationRegex =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/

export const OLD_KEYS = [
  'displayName',
  'lastName',
  'userName',
  'userType',
  'hasVerifiedEmail',
  'redirect',
  'userId',
  'isLogin',
  'fetchWalletOnLoad',
  'changePasswordAccessToken',
  'userEmail',
  'userPicture',
]

export const NOTIF_TAB = {
  ALL: 'all',
  UNREAD_ONLY: 'unreadOnly',
}

export const FULL_TIME = 'FT'

export const POSITION_OBJ = {
  Goalkeeper: 'Goalkeeper',
  Defender: 'Defender',
  Midfielder: 'Midfielder',
  Attacker: 'Attacker',
}

export const HeadToHeadValueString = 'head_to_head'

const SUPPORTED_LEAGUES = {
  UCL: 2, // Champions league
  EPL: 8, // English Premier league
  INTL_FRIENDLIES: 1082,
  EUROS: 1326,
  CLUB_WORLD_CUP: 3412,
  LALIGA: 564,
  SERIE_A: 384,
  BUNDESLIGA: 82,
}

// Invert SUPPORTED_LEAGUES: { 8: 'EPL', 2: 'UCL' }
export const supportedLeaguesLookupByValues = Object.entries(
  SUPPORTED_LEAGUES
).reduce((acc, [key, value]) => {
  acc[value] = key
  return acc
}, {})

export const leaguesInMatchweekFormat = [SUPPORTED_LEAGUES['EPL']]

export const SQUAD_SIZE = 15

export const PARA_ENV = isProd ? Environment.PRODUCTION : Environment.BETA
export const PARA_API_KEY = isProd ? PARA_PROD_KEY : PARA_DEV_KEY

export const GAME_ROOM_CATEGORIES = {
  SELF_PROMOTING: 'self_promoting',
  SPONSORED: 'sponsored',
  SPONSORED_AND_SELF_PROMOTING: 'sponsored_and_self_promoting',
}

export const TURNSTILe_SITE_KEY = isProd
  ? '0x4AAAAAABh8fBw-gFrcIbzt'
  : '1x00000000000000000000AA'
// 1x00000000000000000000AA
// 1x00000000000000000000BB

export const GameRoomPopupObject = {
  SHOW_GROUND: 'SHOW_GROUND',
  SAVE_LINEUP: 'SAVE_LINEUP',
  JOIN_CONFIRMATION: 'CONFIRMATION',
  ALREADY_SAVED_LINEUP: 'ALREADY_SAVED',
  JOIN_SUCCESS: 'JOIN_SUCCESS',
  ROOM_STATUS: 'ROOM_STATUS',
  HAS_JOINED: 'HAS_JOINED',
  EDIT_LINEUP: 'EDIT_LINEUP',
  SAVE_EDIT_LINEUP: 'SAVE_EDIT_LINEUP',
  ASK_QUESTING_WALLET: 'ASK_QUESTING_WALLET',
}

export const allowedTokens = ['CAMP', 'CCD', 'STRK', 'ETH', 'XDC']

export const navLinks = [
  { to: '/game-rooms', label: 'Game Rooms' },
  { to: '/global-leader-board', label: 'Leaderboard' },
  { to: '/fixtures', label: 'Fixtures' },
]

export const profileLinks = [
  {
    to: '/dashboard',
    icon: 'bi bi-grid-1x2',
    label: 'Dashboard',
  },
  {
    to: '/profile',
    icon: 'bi bi-person',
    label: 'Profile',
  },
  {
    to: '/global-leader-board',
    icon: 'bi bi-trophy',
    label: 'Leaderboard',
  },
  {
    to: '/game-rooms',
    icon: 'bi bi-hdd-stack',
    label: 'Game Rooms',
  },
  {
    to: '/joined-games',
    icon: 'bi bi-person-plus',
    label: 'Joined Games',
  },
  {
    to: '/Wallet',
    icon: 'bi bi-wallet2',
    label: 'Wallet',
  },
  {
    to: '/refer',
    icon: 'bi bi-person-add',
    label: 'Refer',
  },
  {
    to: '/logout',
    icon: 'bi bi-box-arrow-right',
    label: 'Logout',
    navLink: true,
  },
]
